module.exports = __webpack_public_path__ + "static/capitol-5-ce3f76776d103aad9ec22c92ea3fbcc3.jpg";